import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { newsList } from "@/mocks/news";

const latest = [...newsList]
  .sort((a, b) => (a.date < b.date ? 1 : -1))
  .slice(0, 6);

export default function LatestNews() {
  const [headline, ...rest] = latest;

  return (
    <section className="mx-auto w-full max-w-[1200px] px-4 py-14 md:px-6 md:py-20">
      <SectionHeading
        eyebrow="Latest"
        title="最新资讯与剧情解读"
        description="剧情分析、角色访谈、幕后花絮与行业动态，陪你读懂每一部仙侠作品。"
        action={
          <Link
            to="/news"
            className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-primary-300 px-5 py-2.5 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-50"
          >
            全部资讯
            <i className="ri-arrow-right-line"></i>
          </Link>
        }
      />

      <div className="mt-8 grid grid-cols-1 gap-5 lg:grid-cols-2">
        <Link
          to="/news"
          className="group relative flex h-72 flex-col justify-end overflow-hidden rounded-lg md:h-full md:min-h-[420px]"
        >
          <img
            src={headline.image}
            alt={headline.title}
            title={`${headline.title} 资讯封面`}
            className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-primary-950/92 via-primary-950/50 to-transparent"></div>
          <div className="relative z-10 p-5 md:p-7">
            <span className="rounded-full bg-accent-500 px-3 py-1 text-xs font-semibold text-primary-950">
              {headline.category}
            </span>
            <h3 className="mt-4 font-heading text-xl font-bold leading-snug text-background-50 md:text-2xl">
              {headline.title}
            </h3>
            <p className="mt-3 line-clamp-2 text-sm leading-relaxed text-primary-100">
              {headline.excerpt}
            </p>
            <div className="mt-4 flex items-center gap-4 text-xs text-primary-200">
              <span className="flex items-center gap-1.5">
                <i className="ri-calendar-line"></i>
                {headline.date}
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-user-line"></i>
                {headline.author}
              </span>
            </div>
          </div>
        </Link>

        <div className="flex flex-col gap-3">
          {rest.map((item) => (
            <Link
              key={item.id}
              to="/news"
              className="group flex gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300"
            >
              <span className="h-20 w-28 shrink-0 overflow-hidden rounded-md bg-background-200 md:h-24 md:w-36">
                <img
                  src={item.image}
                  alt={item.title}
                  title={`${item.title} 资讯封面`}
                  className="h-full w-full object-cover object-top"
                />
              </span>
              <span className="flex min-w-0 flex-1 flex-col justify-center">
                <span className="flex items-center gap-2 text-xs">
                  <span className="rounded-full bg-secondary-100 px-2 py-0.5 font-medium text-secondary-800">
                    {item.category}
                  </span>
                  <span className="text-foreground-400">{item.date}</span>
                </span>
                <span className="mt-2 line-clamp-2 font-heading text-sm font-semibold leading-snug text-foreground-900 group-hover:text-primary-700 md:text-base">
                  {item.title}
                </span>
                <span className="mt-1.5 line-clamp-1 text-xs text-foreground-500">
                  {item.excerpt}
                </span>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}